import useInView from '../../../hooks/useInView';
import './About.css';

function About() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      id="about-section"
      className={isInView ? 'is-inview' : undefined}
      aria-label="About"
      ref={ref}
    >
      <div className="about-intro">
        <h1 id="about-heading" className="reveal">
          Hi, I'm Siraaj.
        </h1>
        <p className="about-secondary reveal reveal-delay-1">
          I develop apps in my free time.
        </p>
        <p className="about-paragraph reveal reveal-delay-2">
          My apps are simple, easy to use, and completely free. They don't have ads, subscriptions, accounts, or popups. They don't collect any user data.
        </p>
      </div>
    </section>
  );
}

export default About;
